export default __webpack_public_path__ + "static/media/10.8dc3862a.png";